<template>
  <!--
  This essentially disables the component for the time being.
  The number of purchase orders + the number of things inside those
  purchase orders causes this component to severely slow down renders.
  Until the method for checking inclusing in a PO has been updated,
  this component should remain disabled.
-->
  <div
    v-if="false"
    class="purchase-order-preview-component"
  >
    <div class="toggle">
      <icon
        class="toggle-icon"
        name="notes"
      />
      <div class="purchase-orders">
        <div
          v-for="po in purchaseOrders"
          :key="po.id"
          class="purchase-order"
        >
          <icon
            v-if="inPO(po.id)"
            class="po-status-icon"
            name="check"
            variant="39b54a"
          />
          <icon
            v-else
            class="po-status-icon"
            name="cross"
            variant="f85359"
          />
          <div class="po-details">
            <span class="po-id">ID: {{ po.id }}</span>
            <span class="po-name">{{ po.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  components: { Icon },
  props: {
    resource: {
      type: Object,
    },
  },
  computed: {
    purchaseOrders() {
      return this.$store.getters['purchaseOrders/all'].filter(po => !po.classificationId || po.classificationId === this.user.classificationId);
    },
    user() {
      return this.$store.getters['session/currentUser'];
    },
  },
  methods: {
    inPO(purchaseOrderId) {
      return (this.resource?.unlockedBy || []).includes(purchaseOrderId);
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-order-preview-component {
  margin: 0 rem-calc(8);

  .toggle {
    position: relative;

    &:hover {
      .purchase-orders {
        display: block;
      }
    }

    .toggle-icon {
      width: rem-calc(16);
      height: rem-calc(16);
    }

    .purchase-orders {
      display: none;
      position: absolute;
      z-index: 20;
      top: rem-calc(24);
      left: -100px;
      background: #FFFFFF;
      width: 200px;
      border-radius: 8px;
      padding: 8px;
      box-shadow: 0 0 2px rgba(0,0,0,0.25);
      text-overflow: ellipsis;

      .purchase-order {
        padding: 8px;
        border-bottom: 1px solid #f0f0f0;

        .po-status-icon {
          width: rem-calc(24);
          height: rem-calc(24);
        }

        .po-details {
          display: inline-block;
          margin-left: 8px;

          .po-id {
            font-size: rem-calc(12);
            color: #767676;
            display: block;
          }

          .po-name {
            font-size: rem-calc(14);
            color: #000000;
            display: block;
          }
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
